export const linksSwe =[
"https://www.naturvardsverket.se/Om-Naturvardsverket/Publikationer/ISBN/6800/978-91-620-6865-3/",
"https://www.su.se/forskning/fyra-av-nio-planet%C3%A4ra-gr%C3%A4nser-%C3%B6verskrids-1.218028",
"https://www.ipcc.ch/report/ar6/wg1/",
"https://ukcop26.org/",
];